import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppShell from '../layouts/AppShell';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AppRoutes from './AppRoutes';
import { trackPageView } from '../shared/analytics/ga4';
import SeoManager from '../shared/seo/SeoManager';

const RoutedShell = () => {
  const location = useLocation();
  const isDesignSystemRoute = location.pathname.startsWith('/design-system');
  const isImmersiveBriefingRoute =
    location.pathname.startsWith('/insights/healthcare-payers') ||
    location.pathname.startsWith('/insights/hospitals') ||
    location.pathname.startsWith('/insights/supermarkets');

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return (
    <AppShell
      header={isDesignSystemRoute || isImmersiveBriefingRoute ? null : <Header />}
      footer={isDesignSystemRoute || isImmersiveBriefingRoute ? null : <Footer />}
    >
      <SeoManager />
      <AppRoutes />
    </AppShell>
  );
};

const AppBootstrap = () => {
  return (
    <BrowserRouter>
      <RoutedShell />
    </BrowserRouter>
  );
};

export default AppBootstrap;
